import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PictureInPictureIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M20 4H4C2.895 4 2 4.895 2 6V18C2 19.105 2.895 20 4 20H20C21.105 20 22 19.105 22 18V6C22 4.895 21.105 4 20 4ZM19 12H13C12.448 12 12 11.552 12 11V7C12 6.448 12.448 6 13 6H19C19.552 6 20 6.448 20 7V11C20 11.552 19.552 12 19 12Z"
      fill={props.sx?.color || '#B5B7BB'}
    />
  </SvgIcon>
);

PictureInPictureIcon.propTypes = {
  sx: PropTypes.object,
};

export default PictureInPictureIcon;
